import { useTranslation } from 'react-i18next';

export const SignTermsPopup = () => {
  const { t } = useTranslation();

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-walletConnectBlur px-2">
      <div
        className="relative max-w-md rounded-lg border border-b-4 border-black bg-popupBackground p-6 text-center shadow-lg"
      >
        <h1 className="text-xl font-bold uppercase text-white">{t('signWalletPopup.title')}</h1>
        <p className="mt-2">{t('signWalletPopup.description')}</p>
        <span className="loader mx-auto mt-4 block" />
        <button
          type="button"
          className="green-button relative mx-auto mt-4 flex h-[50px] w-[300px] items-center justify-center rounded px-4 py-2 font-bold uppercase text-white"
          disabled
        >
          {t('signWalletPopup.waitingForConfirmation')}
        </button>
      </div>
    </div>
  );
};
